import type { Action, ActionStatus } from "../../types/actions";
import type { ActionResponseApi, ActionViewApi } from "../models/action";

const STATUS_MAP: Record<number, ActionStatus> = {
	0: "open",
	1: "complete",
	2: "archived",
};

function parseDate(value: string): Date {
	return new Date(value);
}

export function mapActionViewToAction(api: ActionViewApi): Action {
	const status = STATUS_MAP[api.status] ?? "open";

	const action: Action = {
		id: String(api.id),
		title: api.title,
		description: api.description ?? undefined,
		assignedTo: api.assigneeId,
		assignedBy: api.authorId,
		dueDate: parseDate(api.dueDate),
		status,
		createdAt: parseDate(api.dateCreated),
		comments: [],
		auditLog: [],
		messageCount: api.messageCount,
		completedAt: status === "complete" ? parseDate(api.statusDate) : undefined,
		completionComment:
			status === "complete" ? (api.statusComment ?? undefined) : undefined,
		archivedAt: status === "archived" ? parseDate(api.statusDate) : undefined,
		archivedById:
			status === "archived" ? (api.statusUserId ?? undefined) : undefined,
		archivedByName: undefined,
	};

	return action;
}

export function mapActionResponseToAction(api: ActionResponseApi): Action {
	const status = STATUS_MAP[api.status] ?? "open";

	return {
		id: String(api.id),
		title: api.title,
		description: api.description ?? undefined,
		assignedTo: api.assigneeId,
		assignedBy: api.authorId,
		dueDate: parseDate(api.dueDate),
		status,
		createdAt: parseDate(api.dateCreated),
		comments: [],
		auditLog: [],
		completedAt: status === "complete" ? parseDate(api.statusDate) : undefined,
		completionComment:
			status === "complete" ? (api.statusComment ?? undefined) : undefined,
		archivedAt: status === "archived" ? parseDate(api.statusDate) : undefined,
		archivedById:
			status === "archived" ? (api.statusUserId ?? undefined) : undefined,
		archivedByName: undefined,
	};
}

export function formatDateOnly(date: Date): string {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}
